import React from 'react';
import { Menu } from 'semantic-ui-react';

export interface IMenuItem {
  name: string;
  label: string;
  active: boolean;
}

export interface IProjectMenu {
  items: IMenuItem[];
  onClick: (_name: string) => void;
}

const ProjectMenu = (props: IProjectMenu) => {
  const { items, onClick } = props;

  const handleClick = (item: IMenuItem) => {
    onClick(item.name);
  };

  return (
    <Menu borderless tabular={true}>
      {items.map((item, idx) => {
        return (
          <Menu.Item
            borderless={'true'}
            key={idx}
            name={item.name}
            onClick={() => handleClick(item)}
            active={item.active}
          >
            {item.label}
          </Menu.Item>
        );
      })}
    </Menu>
  );
};

export default ProjectMenu;
